import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ImageMap } from "@qiuz/react-image-map";
import { CircularProgress } from "@mui/material";

const SecurityImage = ({
  building,
  floor,
  setRoom,
  setSelectedTime,
  date,
  setTooltipRoom,
  setTooltipPosition,
  showDetail,
  setShowDetail,
}) => {
  const [mapArea, setMapArea] = useState(
    floor.rooms.map((room) => {
      return {
        ...room,
        left: room.leftPin,
        top: room.topPin,
        onMouseOver: (e) => {
          if (e.target.style.color !== `rgb(${room.color})`) {
            e.target.style.background = `rgba(${room.color}, 0.1)`;
            e.target.style.border = `2px solid rgb(${room.color})`;
            e.target.style.cursor = "pointer";
          }
          setTooltipRoom(room);
          setShowDetail(true);
        },
        onMouseOut: (e) => {
          if (e.target.style.color !== `rgb(${room.color})`) {
            e.target.style.background = ``;
            e.target.style.border = ``;
            e.target.style.cursor = "";
          }
          setShowDetail(false);
        },
        selected: false,
      };
    })
  );

  // const [mapArea, setMapArea] = useState([
  //   {
  //     left: '63%',
  //     top: '75%',
  //     height: '4%',
  //     width: '10%',
  //     style: {
  //       background: 'rgb(0,128,0,0.1)',
  //       border: '2px solid rgb(0,128,0)',
  //       cursor: 'pointer',
  //     },
  //   },
  // ]);

  const floorImage = useSelector(
    (state) => state.performanceDashboard.data?.floorImage
  );

  return (
    <div>
      {floorImage ? (
        <ImageMap
          className="usage-map"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
          src={floorImage}
          map={mapArea}
          onMapClick={(area, index) => {
            if (!area.selected) {
              let areas = [...mapArea];
              // deselect everything
              for (let i = 0; i < areas.length; i++) {
                if (areas[i].selected) {
                  areas[i] = {
                    ...areas[i],
                    selected: false,
                  };
                  delete areas[i]["style"];
                }
              }
              // then select clicked area
              areas[index] = {
                ...area,
                selected: true,
                style: {
                  background: `rgba(${areas[index].color}, 0.1)`,
                  border: `2px solid rgb(${areas[index].color})`,
                  cursor: "pointer",
                  color: `rgb(${areas[index].color})`,
                },
              };
              setMapArea(areas);
              let room = { ...area };
              delete room["left"];
              delete room["top"];
              delete room["onMouseOver"];
              delete room["onMouseOut"];
              delete room["selected"];
              setRoom(room);
              setSelectedTime(date);
              console.log(mapArea, index);
            } else {
              let areas = [...mapArea];
              areas[index] = {
                ...area,
                selected: false,
              };
              delete areas[index]["style"];
              setMapArea(areas);
              setRoom(undefined);
              setSelectedTime(date);
              console.log(mapArea, index, areas[index]);
            }
          }}
        />
      ) : (
        <CircularProgress />
      )}
    </div>
  );
};

export default SecurityImage;
